<template>
  <div class="mc-form">
    <h4 class="card-title">Biodata</h4>

    <b-card>
      <b-row>
        <b-col sm="12" md="6" class="mt-3 mb-5">
          <b-row>
            <b-col md="3">
              <b-skeleton width="100%" height="50px" />
            </b-col>
            <b-col md="9">
              <b-skeleton width="100%" height="50px" />
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="3" class="mt-3 mb-5">
          <b-skeleton width="100%" height="50px" />
        </b-col>
        <b-col sm="12" md="3" class="mt-3 mb-5">
          <b-skeleton width="100%" height="50px" />
        </b-col>
        <b-col sm="12" md="3" class="my-2">
          <b-skeleton width="70%" height="50px" />
        </b-col>
        <b-col sm="12" md="3" class="my-2">
          <b-skeleton width="100%" height="50px" />
        </b-col>
        <b-col sm="12" md="3" class="my-2">
          <b-skeleton width="100%" height="50px" />
        </b-col>
        <b-col sm="12" md="3" class="my-2">
          <b-skeleton width="100%" height="50px" />
        </b-col>
        <b-col sm="12" md="3" class="my-2">
          <b-skeleton width="100%" height="50px" />
        </b-col>
        <b-col sm="12" md="3" class="my-2">
          <b-skeleton width="100%" height="50px" />
        </b-col>
        <b-col sm="12" md="3" class="my-2">
          <b-skeleton width="100%" height="50px" />
        </b-col>
      </b-row>
    </b-card>

    <h4 class="card-title">
      {{ $t('master.form.employee.job') }}
    </h4>

    <b-card>
      <b-row>
        <b-col sm="12" md="3" class="my-2">
          <b-skeleton width="100%" height="50px" />
        </b-col>
        <b-col sm="12" md="3" class="my-2">
          <b-skeleton width="100%" height="50px" />
        </b-col>
        <b-col sm="12" md="3" class="my-2">
          <b-skeleton width="100%" height="50px" />
        </b-col>
        <b-col sm="12" md="3" class="my-2">
          <b-skeleton width="100%" height="50px" />
        </b-col>
      </b-row>
    </b-card>

    <div class="clearfix mb-3">
      <div class="float-start">
        <h4 class="card-title">{{ $t('master.form.employee.identity.title') }}</h4>
      </div>

      <div class="float-end">
        <McButton
          variant="primary"
          icon="icon-outline_plus"
          :text="$t('global.addField')"
          disabled
        />
      </div>
    </div>

    <b-card>
      <div class="my-3">
        <b-skeleton width="100%" height="100px" />
      </div>
    </b-card>

    <div class="clearfix mb-3">
      <div class="float-start">
        <h4 class="card-title">{{ $t('master.form.employee.jobHistory.title') }}</h4>
      </div>

      <div class="float-end">
        <McButton
          variant="primary"
          icon="mc-fa icon-outline_plus"
          :text="$t('global.addField')"
          disabled
        />
      </div>
    </div>

    <b-card>
      <div class="my-3">
        <b-skeleton width="100%" height="100px" />
      </div>
    </b-card>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
}
</script>
